import React, { useState } from "react";
import PageLayout from "@/components/layout/PageLayout";
import Seo from "@/components/foundation/Seo";

import HeroSection from "@/components/home/HeroSection";
import TrustBarSection from "@/components/home/TrustBarSection";
import ZenScoreSection from "@/components/home/ZenScoreSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import SecuritySection from "@/components/home/SecuritySection";
import FeaturesSection from "@/components/home/FeaturesSection";
import AppShowcaseSection from "@/components/home/AppShowcaseSection";
import WhyZenMeSection from "@/components/home/WhyZenMeSection";
import PartnersTeaserSection from "@/components/home/PartnersTeaserSection";
import RoadmapSection from "@/components/home/RoadmapSection";
import FaqSection from "@/components/home/FaqSection";
import FinalCtaSection from "@/components/home/FinalCtaSection";
import ComingSoonModal from "@/components/marketing/ComingSoonModal";

export default function Home() {
  const [modal, setModal] = useState({ open: false, source: "hero_qualify" });
  const openModal = (source) => setModal({ open: true, source });
  const setOpen = (open) => setModal((s) => ({ ...s, open }));

  return (
    <PageLayout>
      <Seo
        title="ZenMe Capital · Business Funding Powered by AI"
        description="AI-powered business funding with ZenScore. Securely connect your business bank via Mastercard Finicity, receive your ZenScore, and unlock personalized funding opportunities."
        path="/"
      />

      <HeroSection onQualifyClick={() => openModal("hero_qualify")} />
      <TrustBarSection />
      <ZenScoreSection />
      <HowItWorksSection />
      <SecuritySection />
      <FeaturesSection />
      <AppShowcaseSection />
      <WhyZenMeSection />
      <PartnersTeaserSection />
      <RoadmapSection />
      <FaqSection />
      <FinalCtaSection onQualifyClick={() => openModal("final_cta_qualify")} />

      <ComingSoonModal
        open={modal.open}
        onOpenChange={setOpen}
        source={modal.source}
        mode="qualify"
      />
    </PageLayout>
  );
}
